module.exports = __webpack_public_path__ + "img/20210501_085537.6b02f69f.jpg";